import careers1 from "../../../media/111.png";
import careers2 from "../../../media/191.png";
import careers3 from "../../../media/testi.png";
import careers4 from "../../../media/222.png";
import careers5 from "../../../media/1000.png";
import testimonialA1 from "../../../media/testimonial_a1.png";
import testimonialA2 from "../../../media/testimonial_a2.png";
import testimonialB from "../../../media/testimonial_b.png";
import testimonialC from "../../../media/testimonial_c.png";
import testimonialD1 from "../../../media/testimonial_d1.png";
import testimonialD2 from "../../../media/testimonial_d2.png";
import testimonialE1 from "../../../media/testimonial_e1.png";
import testimonialE2 from "../../../media/testimonial_e2.png";
import testimonialF from "../../../media/testimonial_f.png";
import CarouselComponent from "../../UI/CarouselComponent";

const slides = [
  careers1,
  careers3,
  careers4,
  careers5,
  careers2,
  testimonialA1,
  testimonialA2,
  testimonialB,
  testimonialC,
  testimonialD1,
  testimonialD2,
  testimonialE1,
  testimonialE2,
  testimonialF,
];

const CareersCarousel = () => {
  return (
    <div className="bg-skin py-20">
      <h1 className="text-brown text-5xl font-medium text-center mb-12">
        Insights from Past Interns
      </h1>
      <CarouselComponent className="py-20 justify-center align-center">
        {slides.map((src, index) => (
          <div key={index}>
            <img
              className="m-auto max-w-[90%] sm:max-w-[80%] md:max-w-[70%] lg:max-w-[60%] xl:max-w-[50%]"
              src={src}
              alt="Intern testimonial"
            />
          </div>
        ))}
      </CarouselComponent>
    </div>
  );
};
export default CareersCarousel;
